import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { Card } from 'antd';
import ModelForm from './ModelForm';
import CompanyDetailActions from '../../Stores/CompanyDetail/Actions';

class CompanyDetailScreen extends React.PureComponent {
  componentDidMount() {
    const { match, setReslId } = this.props;

    if (match.params.action === 'create') {
      setReslId(0);
    } else if (match.params.action === 'update') {
      setReslId(parseInt(match.params.id, 10));
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  render() {
    const { intl, match, model } = this.props;

    return (
      <Card title={`${intl.formatMessage({ id: 'company' })} ${model.code}`}>
        <ModelForm match={match} />
      </Card>
    );
  }
}

CompanyDetailScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  setReslId: PropTypes.func,
  model: PropTypes.shape({
    id: PropTypes.number,
    code: PropTypes.string
  })
};

CompanyDetailScreen.defaultProps = {
  intl: {},
  match: {},

  setReslId() {},
  model: { id: 0, code: '' }
};

const mapStateToProps = state => ({
  model: state.companyDetail.model
});

const mapDispatchToProps = dispatch => ({
  setReslId: resId => dispatch(CompanyDetailActions.companyDetailSetResId(resId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CompanyDetailScreen));
